module.exports = __webpack_public_path__ + "img/pos_terima.2a7fb1de.png";